<template>
  <v-layout>
    <v-flex xs12 sm10 md8 class="form-container">
      <v-layout wrap>
        <v-flex xs12>
          <div v-if="$apollo.loading">
            <spinner />
          </div>
          <form v-else v-scroll-to-error>
            <div class="screen-title mb-32">
              <span>Announcement</span>
            </div>
            <announcement-form
              :initial-values="form"
              :vs="$v"
              disabled
              @values="form=$event"
            />
            <main-button
              text="Delete"
              color="error"
              flat
              @click.prevent="showDeleteDialog = true"
            />
            <main-button text="Cancel" flat @click.prevent="goBack" />
          </form>
        </v-flex>
      </v-layout>
    </v-flex>
    <delete-dialog
      :content="`Are you sure you want to delete this announcement? This operation cannot be undone.`"
      :on-delete="deleteAnnouncement"
      :show.sync="showDeleteDialog"
      title="Remove announcement"
    />
  </v-layout>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import DeleteDialog from './../shared/dialogs/delete-dialog.vue'
import AnnouncementForm from './announcement-form.vue'
import MainButton from './../shared/main-button'
import Spinner from './../shared/spinner'
import { deleteAnnouncement, getAnnouncement } from './../../http'
import { GET_ANNOUNCEMENT } from '../../graphql/announcement.graphql'


export default {
  name: 'display-announcement-container',
  components: {
    AnnouncementForm,
    MainButton,
    Spinner,
    DeleteDialog,
  },
  props: {
    eventId: {
      default: null,
      type: String,
    },
    id: {
      default: null,
      type: String,
    },
  },
  validations() {
    return {
      form: {
        title: { required },
        text: { required },
      },
    }
  },
  data: () => ({
    showDeleteDialog: false,
    announcement: {},
    form: {},
  }),
  apollo: {
    getEventAnnouncement: {
      query: GET_ANNOUNCEMENT,
      variables() {
        return {
          eventId: this.eventId,
          id: this.id,
        }
      },
      manual: true,
      result({ loading, data }) {
        if (!loading) {
          const { getAnnouncement: announcement } = data
          this.form = announcement
        }
      },
    },
  },
  methods:{
    async deleteAnnouncement() {
      await deleteAnnouncement({
        eventId: this.eventId,
        id: this.id})
      this.goBack()
    },
  },
}
</script>

<style>
.form-container {
  margin-right: 30px;
}
</style>
